// extracted by mini-css-extract-plugin
export default {"content":"styles_content__Oa0ET"};